import type { TradingAPIAPIError } from '../gen/types/legacy-platform'

function isAPIError(data: unknown): data is TradingAPIAPIError {
  return (
    typeof data === 'object' &&
    data !== null &&
    'error' in data &&
    typeof (data as TradingAPIAPIError).error === 'string'
  )
}

export class HorizonError extends Error {
  status: number
  data: TradingAPIAPIError
  headers: Headers

  constructor(status: number, data: unknown, headers: Headers) {
    const parsed: TradingAPIAPIError = isAPIError(data)
      ? data
      : { error: String(data), error_type: 'server_error' }

    super(parsed.error)
    this.name = 'HorizonError'
    this.status = status
    this.data = parsed
    this.headers = headers
  }
}
